import { WorkflowsCreatePayload } from '@api/types.gen';

import {
  StaggerConfig,
  StaggerOption,
} from '@/react/edge/edge-stacks/components/StaggerFieldset.types';
import { RelativePathModel } from '@/react/portainer/gitops/RelativePathFieldset/types';

import { Artifact, FormValues } from '../wizard/types';
import {
  toEnvVarsPayload,
  toFilesPayload,
  toParallelDeploymentConfig,
} from '../wizard/payload';

export function toCreateWorkflowPayload(
  values: FormValues
): WorkflowsCreatePayload {
  return {
    name: values.name,
    artifacts: values.artifacts.map((artifact) => toArtifactPayload(artifact)),
  };
}

function toArtifactPayload(
  artifact: Artifact
): WorkflowsCreatePayload['artifacts'][number] {
  return {
    name: artifact.name,
    deploymentType: artifact.deploymentType,
    files: toFilesPayload(artifact.files),
    targets: { edgeGroups: artifact.targets },
    config: {
      prePullImage: artifact.config.prePullImage,
      retryPeriod: artifact.config.retryDeploy
        ? artifact.config.retryPeriod
        : undefined,
      envVars: toEnvVarsPayload(artifact.config.envVars),
      parallelConfig: toParallelConfig(artifact.config.parallelConfig),
      registries: artifact.config.registryId
        ? [artifact.config.registryId]
        : undefined,
      useManifestNamespaces: artifact.config.useManifestNamespaces,
      ...toRelativePathConfig(artifact.config.relativePath),
    },
  };
}

function toRelativePathConfig(relativePath: RelativePathModel) {
  return {
    ...(relativePath.SupportRelativePath
      ? {
          alwaysCloneGitRepoForRelativePath:
            relativePath.AlwaysCloneGitRepoForRelativePath,
          localFilesystemPath: relativePath.FilesystemPath,
        }
      : {}),
    ...(relativePath.SupportPerDeviceConfigs
      ? {
          perDeviceConfigsPath: relativePath.PerDeviceConfigsPath,
          perDeviceConfigsMatchType:
            relativePath.PerDeviceConfigsMatchType || undefined,
          perDeviceConfigsGroupMatchType:
            relativePath.PerDeviceConfigsGroupMatchType || undefined,
        }
      : {}),
  };
}

function toParallelConfig(config: StaggerConfig) {
  if (config.StaggerOption !== StaggerOption.Parallel) {
    return undefined;
  }

  return toParallelDeploymentConfig(config);
}
